import React from 'react'
import { motion } from 'framer-motion'

type TProps = {
  title: string
  className?: string
}

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08,
    },
  },
}

const word = {
  hidden: {
    y: '100%',
  },
  visible: {
    y: '0%',
    transition: {
      duration: 0.8,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
}

export default function TitleAni({ title, className }: TProps) {
  return (
    <motion.h2
      className={`title-ani title-main ${className || ''}`}
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.6 }}
      style={{ overflow: 'hidden' }}
    >
      {title.split(' ').map((w, i) => (
        <span
          key={i}
          style={{
            display: 'inline-block',
            overflow: 'hidden',
            marginRight: '0.25em',
          }}
        >
          <motion.span style={{ display: 'inline-block' }} variants={word}>
            {w}
          </motion.span>
        </span>
      ))}
    </motion.h2>
  )
}
